<script lang="ts" setup>

//emits
const emit = defineEmits(['onClick']);

//props
const props = defineProps({
    checked: { type: Boolean, default: false, required: false }
});


const onClick = () => {
    emit('onClick');
}
</script>

<template>
    <div class="sai-checkbox-single">
        <img v-if="!checked" src="@/assets/img/icon-checkbox.svg" @click="onClick"/>
        <img v-if="checked" src="@/assets/img/icon-checkbox-active.svg" @click="onClick"/>
    </div>
</template>
<style lang="scss">
    @use './style.scss';
</style>